<template>
    <section class="video-sec4">
        <div v-if="width > 1024" class="video-sec4-bg"></div>
        <div class="video-sec4-container">
            <img v-if="width > 768" src="../assets/images/videoAd-pic3.png" alt="" class="video-sec4-img" />
            <div class="video-sec4-content">
                <div class="video-sec4-header">
                    <img v-if="width <= 768" src="../assets/images/videoAd-pic8.png" alt="" />
                    <h2>چرا تبلیغات ویدیویی؟</h2>
                </div>
                 <div class="video-sec4-list">
                    <div>
                        <img src="../assets/images/videoAd-pic6.png" alt="" />
                        <p>ایجاد آگاهی از برند و اعتماد سازی</p>
                    </div>
                    <div>
                        <img src="../assets/images/videoAd-pic7.png" alt="" />
                        <p>ایجاد ارتباطی موثر با مخاطب</p>
                    </div>
                 </div>
            </div>
        </div>
    </section>
</template>

<script>
import { inject } from 'vue';
export default {
    name: "VideoSection4",
    setup() {
        const width = inject('viewportWidth');

        return {
            width,

        }
    }
};
</script>

<style scoped>
.video-sec4 {
     max-height: 393px;
     padding-block: 3.27%;
     position: relative;
}

.video-sec4-bg {
    height: 299px;
    background-image: url('../assets/images/section-bg-4.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.video-sec4-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    margin-inline: 10.973% 21.792%;
    height: 100%;
    gap: 20px;
}

.video-sec4-container,
.video-sec4-header {
       justify-content: space-between;
}

.video-sec4-container,
.video-sec4-content,
.video-sec4-header,
.video-sec4-list,
.video-sec4-list div {
    display: flex;
}

.video-sec4-container,
.video-sec4-header,
.video-sec4-list,
.video-sec4-list div {
    align-items: center;
}

.video-sec4-img {
    aspect-ratio: 399 / 392;
    width: 44%;
    max-width: 399px;
    max-height: 392px;
    flex-shrink: 0;
    animation: fadeRight 2s ease-out forwards;
}

.video-sec4-img,
.video-sec4-header img {
     object-fit: contain;
}

.video-sec4-content,
.video-sec4-list div {
    flex-direction: column;
}

.video-sec4-header {
    margin-bottom: 20.2%;
}

.video-sec4-header img {
    aspect-ratio: 1 / 1;
    width: 60px;
}

.video-sec4-header h2 {
    font-size: 28px;
    line-height: 38px;
    font-family: 'IRANYekan-Bold';
}

.video-sec4-list {
    justify-content: space-around;
    gap: 24px;
}

.video-sec4-list div {
    justify-content: space-evenly;
    box-shadow: 0 2px 10px var(--shadow-light);
    backdrop-filter: blur(20px);
    border-radius: 30px;
    width: 162px;
    height: 120px;
}

.video-sec4-list img {
    width: 82px;
    height: 82px;
    margin-top: -41px;
}

.video-sec4-list p {
    font-size: 15px;
    line-height: 26px;
    text-align: center;
}

@media screen and (min-width:1441px) {
    .video-sec4-container {
        width: 955px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1024px) {
    .video-sec4 {
        padding-block: 0;
    }

    .video-sec4-container {
        margin-inline: 9.973%;
        position: unset;
    }

    .video-sec4-img {
        width: 40%;
    }

    .video-sec4-header h2 {
        font-size: 24px;
        line-height: 28px;
    }
}

@media screen and (max-width: 768px) {
    .video-sec4 {
        max-height: 441px;
    }

    .video-sec4-container {
        margin-inline: 11.7%;
        justify-content: center;
    }

     .video-sec4-header {
        gap: 7px;
        margin-bottom: 75px;
     }

    .video-sec4-list {
        flex-direction: column;
        gap: 65px;
    }
}

@media screen and (max-width: 375px) {
    .video-sec4-header {
        margin-bottom: 46px;
    }

    .video-sec4-header h2 {
        font-size: 19px;
    }

    .video-sec4-list p {
        font-size: 14px;
    }
}

</style>